// Libs
import React from 'react';
// Utils
import { ImportUtils } from 'utils/Orders/ImportProcess';
// Components
import { StandardTableScreen } from 'core/ScreenBuilder/screens/StandardTableScreen';
import { IMPORT_ROW_ID_FIELD } from './importReview.model';
import styles from './ImportReview.module.css';

const getImportSelectionAriaLabel = rowData => {
	const diagnostics = rowData?.importDiagnostics || {};
	const orderIdentifier =
		rowData?.odtId ??
		rowData?.orderId ??
		rowData?.orderNumber ??
		diagnostics?.sourceFieldValues?.odtId;
	const rowNumber = diagnostics.rowNumber ?? rowData?.index;
	if (orderIdentifier !== undefined && orderIdentifier !== null)
		return `Seleccionar orden ${orderIdentifier}${
			rowNumber !== undefined && rowNumber !== null ? `, fila ${rowNumber}` : ''
		}`;
	if (rowNumber !== undefined && rowNumber !== null)
		return `Seleccionar fila importada ${rowNumber}`;
	return `Seleccionar fila ${rowData?.__importRowId || ''}`.trim();
};

const TablePreview = ({
	previewOrders,
	fields,
	fieldActions,
	isBusy = false,
	isInteractionBlocked = false,
	selectedRowIds = [],
	onSelectedRowIdsChange = () => {},
}) => {
	const baseDatasourceFields = React.useMemo(() => {
		const configuredFields = fields.filter(
			field => field.id !== 'contractFrequencyId' || field.show === true,
		);
		return new ImportUtils(
			previewOrders,
			configuredFields.concat({
				id: 'delete',
				name: 'Eliminar',
				width: 100,
				filterable: false,
			}),
		).getFormattedFields({});
	}, [previewOrders, fields]);
	const datasourceFields = React.useMemo(
		() =>
			baseDatasourceFields.map(field => ({
				...field,
				...(fieldActions.ids?.[field.id] || {}),
			})),
		[baseDatasourceFields, fieldActions.ids],
	);
	const interactionBlocked = isBusy || isInteractionBlocked;

	return (
		<div className={styles.editableTableContainer} aria-busy={isBusy}>
			<fieldset
				className={styles.editableTableFieldset}
				disabled={interactionBlocked}
			>
				<StandardTableScreen
					isLoading={isBusy}
					selectionKey={IMPORT_ROW_ID_FIELD}
					showSelectionCheckboxes
					disableBulkOrderActions
					selectedItems={selectedRowIds}
					setSelectedItems={onSelectedRowIdsChange}
					dataFilterLastRowId={undefined}
					datasourceFields={datasourceFields}
					datasourcePaging={{ totalLastRowId: 0 }}
					datasource={previewOrders}
					fieldActionTypes={fieldActions.types}
					getSelectionAriaLabel={getImportSelectionAriaLabel}
				/>
			</fieldset>
			{interactionBlocked && (
				<div
					className={styles.editableTableOverlay}
					role={isBusy ? 'status' : undefined}
					aria-live={isBusy ? 'polite' : undefined}
					aria-hidden={isBusy ? undefined : 'true'}
				>
					{isBusy
						? 'Procesando importación. La edición está temporalmente bloqueada.'
						: 'Confirma o cancela la acción masiva para continuar.'}
				</div>
			)}
		</div>
	);
};

export default TablePreview;
